var _excluded = ["onSelect", "validator", "onMountValidation", "selectedOptions", "propsToValidate", "className"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect, useCallback, createRef } from 'react';
import { Flyout } from '@els/els-react--flyout';
import { Icon } from '@els/els-react--icon';
import { TextInput, ValidatedTextInput } from '@els/els-react--text-input';
import { createEnum, appendClass, ValidPropTypes, makeErrorBoundComponent, generateId } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
import { Button } from '@els/els-react--button';
import { TristateCheckbox, Checkbox } from '@els/els-react--checkbox';
var SelectSizes = createEnum(['small', 'large']);
var ValidationModes = createEnum(['invalid', 'neutral', 'valid']);
var DefaultMessages = createEnum({
  oneOptionRequiredMessage: 'Choose at least one option.',
  clearMessage: 'Clear selection',
  searchAvailableOptions: 'Search available options',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  noSearchResults: 'No matches found',
  clearSearch: 'Clear search',
  matchingOptions: 'matching options',
  itemsSelected: 'item(s) selected'
});
function checkRequiredProps(options, onSelect, label) {
  if (!options) {
    throw new Error("Select must have options");
  }
  if (!onSelect) {
    throw new Error("Select must have an onSelect function");
  }
  if (!label) {
    throw new Error("Select must have a label");
  }
}
var generateClasses = function generateClasses(className, shouldSelectionWrap, isDropdownOpen, size, isReadOnly, isDisabledOrReadOnly, isLabelInline, selectionState, validity, isPlainInput, hideSelectedOptions) {
  var baseClasses = [className].join(" ");
  var inputBaseClasses = appendClass({
    className: baseClasses,
    value: "input",
    delimiter: "__"
  });
  var wrapperClasses = classnames("c-els-field--react-select", baseClasses, {
    // Note this block class is in a different position in the tree when shouldSelectionWrap is active
    "c-els-field": shouldSelectionWrap,
    "c-els-field--icon c-els-field--icon-right": shouldSelectionWrap,
    "c-els-field--open": isDropdownOpen,
    "c-els-field--small": size === SelectSizes.SMALL,
    "c-els-field--large": size === SelectSizes.LARGE,
    "c-els-field--read-only": isReadOnly,
    "c-els-field--disabled": isDisabledOrReadOnly,
    "c-els-field--wrapped": shouldSelectionWrap,
    "c-els-field--inline": isLabelInline,
    "c-els-field--unpopulated": !selectionState.length,
    "c-els-field--error": validity === ValidationModes.INVALID,
    "c-els-field--select-inline": isPlainInput
  });
  var iconClasses = classnames("c-els-field__icon-right", {
    "c-els-field__icon--open": isDropdownOpen
  });
  var inputClasses = classnames(
  // DEPRECATED: test class not used within Leyden any more
  "t-els-select-input-test-hook", "c-els-field--icon c-els-field--icon-right", inputBaseClasses, {
    "c-els-field__input c-els-field": shouldSelectionWrap,
    "c-els-field--hide-selected-options": hideSelectedOptions
  });
  return {
    wrapperClasses: wrapperClasses,
    iconClasses: iconClasses,
    inputClasses: inputClasses
  };
};
function validateOptions(options, isMultiSelect, isNestedSelect) {
  if (!options.every(function (entry) {
    return ["string", "number"].includes(_typeof(entry));
  }) && !options.every(function (_ref) {
    var label = _ref.label,
      value = _ref.value;
    return typeof label === "string" && (["string", "number"].includes(_typeof(value)) || Array.isArray(value));
  })) {
    throw new TypeError("Options must be an array of either all strings, numbers, objects of value (string or number) and label (string) properties!");
  } else {
    var entryValues = options.every(function (entry) {
      return _typeof(entry) === "object";
    }) ? options.map(function (entry) {
      return entry.value;
    }) : options;
    if (new Set(entryValues).size !== entryValues.length) {
      throw new Error("Options can not have duplicate values.");
    }
  }
  if (options.some(function (entry) {
    return Array.isArray(entry.value);
  }) && !isMultiSelect) {
    throw new TypeError("If options array contains nested data, isMultiSelect must also be true");
  }
  if (options.some(function (entry) {
    return Array.isArray(entry.value);
  }) && isMultiSelect && !isNestedSelect) {
    throw new TypeError("If options array contains nested data, isMultiSelect (".concat(isMultiSelect, ") and isNestedSelect (").concat(isNestedSelect, ") must also be true"));
  }
  if (!options.every(function (entry) {
    return Array.isArray(entry.value);
  }) && isNestedSelect) {
    throw new TypeError("NestedSelect must have options with nested data in every option");
  }
}
function validateSelectedOptions(selectedOptions, isMultiSelect, options, checkForSelectedOptions, isNestedSelect) {
  if (!Array.isArray(selectedOptions)) {
    throw new Error("Select can have a selectedOptions property of type array only. Property is type ".concat(_typeof(selectedOptions)));
  } else if (!checkForSelectedOptions(selectedOptions, options, isNestedSelect)) {
    throw new Error("SelectedOptions (".concat(selectedOptions, ") can only have values from the options array (").concat(options, ")"));
  } else if (isMultiSelect) {
    if (new Set(selectedOptions).size !== selectedOptions.length) {
      throw new Error("SelectedOptions can not have duplicate values for Multi Select");
    }
  } else if (selectedOptions.length > 1) {
    throw new Error("Non multi select can only have 1 selectedOptions");
  }
}
var array$2 = PT.array,
  arrayOf$3 = PT.arrayOf,
  bool$4 = PT.bool,
  func$4 = PT.func,
  number$2 = PT.number,
  object$2 = PT.object,
  oneOfType$2 = PT.oneOfType,
  shape$5 = PT.shape,
  string$4 = PT.string;
var SelectOptions = function SelectOptions(_ref2) {
  var blankOptionLabel = _ref2.blankOptionLabel,
    isMultiSelect = _ref2.isMultiSelect,
    isNestedSelect = _ref2.isNestedSelect,
    messages = _ref2.messages,
    options = _ref2.options,
    onOptionSelection = _ref2.onOptionSelection,
    selection = _ref2.selection,
    showSearch = _ref2.showSearch,
    showSelectAll = _ref2.showSelectAll,
    selectAll = _ref2.selectAll,
    deselectAll = _ref2.deselectAll,
    toggleDropdown = _ref2.toggleDropdown,
    unpackNestedOptions = _ref2.unpackNestedOptions,
    id = _ref2.id;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var _useState3 = useState(options),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredOptions = _useState4[0],
    setFilteredOptions = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    noFilterResults = _useState6[0],
    setNoFilterResults = _useState6[1];
  var _useState7 = useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    activeIndex = _useState8[0],
    setActiveIndex = _useState8[1];
  var hasNestedData = options.some(function (_ref3) {
    var value = _ref3.value;
    return Array.isArray(value);
  });
  var WrappingElement = isMultiSelect ? "ul" : "div";
  var searchInputRef = useRef();
  var selectAllInputRef = useRef();
  var deselectAllInputRef = useRef();
  var getFilteredNestedOptions = function getFilteredNestedOptions(searchString) {
    return options.filter(function (obj) {
      return (
        // Top level option's label matches
        obj.label.toLowerCase().indexOf(searchString) !== -1 ||
        // Or at least one of that option's nested option labels matches
        obj.value.filter(function (nestedObj) {
          return nestedObj.label.toLowerCase().indexOf(searchString) !== -1;
        }).length !== 0
      );
    });
  };
  var updateSearch = function updateSearch(event) {
    var searchString = event.target.value;
    setSearchTerm(searchString);
    var lowercaseSearchString = searchString.toLowerCase();
    var newFilteredOptions = hasNestedData ? getFilteredNestedOptions(lowercaseSearchString) : options.filter(function (option) {
      var label = _typeof(option) === "object" ? option.label : option;
      return label === blankOptionLabel || label.toLowerCase().indexOf(lowercaseSearchString) !== -1;
    });
    setFilteredOptions(newFilteredOptions);
    setNoFilterResults(newFilteredOptions.length === 0 || newFilteredOptions.length === 1 && (newFilteredOptions[0] === blankOptionLabel || _typeof(newFilteredOptions[0]) === "object" && newFilteredOptions[0].label === blankOptionLabel));
  };
  var getValues = function getValues(visibleOptions) {
    return visibleOptions.map(function (option) {
      return _typeof(option) === "object" ? option.value : option;
    });
  };
  var isSelectedAll = function isSelectedAll(selected, visibleOptions) {
    var newOptions = isNestedSelect ? unpackNestedOptions(visibleOptions) : getValues(visibleOptions);
    return newOptions.every(function (v) {
      return selected.includes(v);
    });
  };
  var isDeselectedAll = function isDeselectedAll(selected, visibleOptions) {
    var newOptions = isNestedSelect ? unpackNestedOptions(visibleOptions) : getValues(visibleOptions);
    return !newOptions.some(function (v) {
      return selected.includes(v);
    });
  };
  var searchKeyDown = function searchKeyDown(event) {
    if (event !== null && event !== void 0 && event.shiftKey && event.key === "Tab") {
      toggleDropdown(event);
    }
  };
  var selectAllKeyDown = function selectAllKeyDown(event) {
    if (event !== null && event !== void 0 && event.shiftKey && event.key === "Tab" && !showSearch) {
      event.preventDefault();
      toggleDropdown(event);
    }
  };
  var deselectAllKeyDown = function deselectAllKeyDown(event) {
    if (event !== null && event !== void 0 && event.shiftKey && event.key === "Tab" && !showSearch && isSelectedAll(selection, options)) {
      event.preventDefault();
      toggleDropdown(event);
    }
  };
  var getCheckboxes = function getCheckboxes() {
    var selectOptionsWrapper = document.getElementById("".concat(id, "-select-options-wrapper"));
    return selectOptionsWrapper.querySelectorAll('[data-testid="checkbox-input"]');
  };
  var onEnter = function onEnter(event) {
    if (isMultiSelect) {
      event.target.click();
    } else {
      toggleDropdown(event);
    }
  };
  var onEscape = function onEscape(event) {
    toggleDropdown(event);
  };
  var onUp = function onUp(event) {
    event.preventDefault();
    if (activeIndex === 0) {
      return;
    }
    var nextActiveIndex = activeIndex - 1;
    if (hasNestedData) {
      var _checkboxes$nextActiv;
      var checkboxes = getCheckboxes();
      (_checkboxes$nextActiv = checkboxes[nextActiveIndex]) === null || _checkboxes$nextActiv === void 0 || _checkboxes$nextActiv.focus();
    } else {
      var optionId = "".concat(id, "-select-options-").concat(nextActiveIndex).concat(isMultiSelect ? "-input" : "");
      document.getElementById(optionId).focus();
      if (!isMultiSelect) {
        onOptionSelection(filteredOptions[nextActiveIndex], true);
      }
    }
    setTimeout(function () {
      setActiveIndex(nextActiveIndex);
    });
  };
  var onDown = function onDown(event) {
    event.preventDefault();
    var nextActiveIndex = activeIndex + 1;
    if (hasNestedData) {
      var checkboxes = getCheckboxes();
      if (checkboxes.length > nextActiveIndex) {
        setTimeout(function () {
          return setActiveIndex(nextActiveIndex);
        });
        checkboxes[nextActiveIndex].focus();
      }
    } else if (nextActiveIndex < filteredOptions.length) {
      setActiveIndex(nextActiveIndex);
      var optionId = "".concat(id, "-select-options-").concat(nextActiveIndex).concat(isMultiSelect ? "-input" : "");
      document.getElementById(optionId).focus();
      if (!isMultiSelect) {
        onOptionSelection(filteredOptions[nextActiveIndex], true);
      }
    }
  };
  var onTab = function onTab(event) {
    if (!(showSearch || showSelectAll) || !(event !== null && event !== void 0 && event.shiftKey)) {
      event.preventDefault();
      toggleDropdown();
    } else if (showSelectAll) {
      event.preventDefault();
      if (!isDeselectedAll(selection, showSearch ? filteredOptions : options)) {
        deselectAllInputRef.current.focus();
      } else {
        selectAllInputRef.current.focus();
      }
    } else {
      event.preventDefault();
      searchInputRef.current.focus();
    }
  };
  var onOptionKeyDown = function onOptionKeyDown(event) {
    switch (event.key) {
      case "Enter":
        onEnter(event);
        break;
      case "Escape":
        onEscape(event);
        break;
      case "ArrowUp":
        onUp(event);
        break;
      case "ArrowDown":
        onDown(event);
        break;
      case "Tab":
        onTab(event);
        break;
    }
  };
  var wrapperClasses = classnames({
    "c-els-field__select-options-fieldset c-els-field--tristate-checkbox": hasNestedData,
    "s-els-no-focus": !isMultiSelect
  });
  return /* @__PURE__ */React.createElement("div", {
    className: "c-els-field__select-options",
    id: "".concat(id, "-select-options-wrapper"),
    "data-testid": "".concat(id, "-select-options-wrapper")
  }, showSearch && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(TextInput, {
    value: searchTerm,
    onChange: updateSearch,
    iconRight: {
      sprite: "Search",
      isDecorative: true
    },
    label: messages.SEARCH_AVAILABLE_OPTIONS,
    shouldHideLabel: true,
    className: "c-els-field__select-options-search",
    autoFocus: true,
    inputRef: searchInputRef,
    onKeyDown: searchKeyDown
  }), /* @__PURE__ */React.createElement("p", {
    className: "c-els-field__select-options-no-results ".concat(noFilterResults ? "" : "u-els-hide-visually"),
    "aria-live": "polite",
    "aria-atomic": "true"
  }, noFilterResults && /* @__PURE__ */React.createElement(React.Fragment, null, messages.NO_SEARCH_RESULTS, ".", " ", /* @__PURE__ */React.createElement(Button, {
    type: "link",
    onClick: function onClick() {
      setFilteredOptions(options);
      setSearchTerm("");
      setNoFilterResults(false);
    },
    "data-testid": "select-clear-button"
  }, messages.CLEAR_SEARCH)), !noFilterResults && /* @__PURE__ */React.createElement("span", null, filteredOptions.length, " ", messages.MATCHING_OPTIONS))), showSelectAll && /* @__PURE__ */React.createElement("ul", {
    className: "c-els-field__select-deselect"
  }, /* @__PURE__ */React.createElement("li", null, /* @__PURE__ */React.createElement(Button, {
    onClick: function onClick() {
      selectAll(showSearch ? filteredOptions : options);
    },
    type: Button.Types.LINK,
    disabled: isSelectedAll(selection, showSearch ? filteredOptions : options),
    innerRef: selectAllInputRef,
    autoFocus: !showSearch && !isSelectedAll(selection, options),
    className: "u-els-margin-right",
    onKeyDown: selectAllKeyDown
  }, messages.SELECT_ALL)), /* @__PURE__ */React.createElement("li", null, /* @__PURE__ */React.createElement(Button, {
    onClick: function onClick() {
      deselectAll(selection, showSearch ? filteredOptions : options);
    },
    type: Button.Types.LINK,
    disabled: isDeselectedAll(selection, showSearch ? filteredOptions : options),
    innerRef: deselectAllInputRef,
    autoFocus: !showSearch && isSelectedAll(selection, options),
    onKeyDown: deselectAllKeyDown
  }, messages.DESELECT_ALL))), /* @__PURE__ */React.createElement(WrappingElement, {
    role: !isMultiSelect ? "listbox" : null,
    "aria-labelledby": "".concat(id, "-select-input-label"),
    "aria-activedescendant": !isMultiSelect ? "".concat(id, "-select-options-").concat(activeIndex) : null,
    tabIndex: "-1",
    onKeyDown: onOptionKeyDown,
    className: wrapperClasses
  }, filteredOptions.map(function (option, index) {
    var optionLabel = _typeof(option) === "object" ? option.label : option;
    var optionValue = _typeof(option) === "object" ? option.value : option;
    var isClearOption = (_typeof(option) === "object" ? option.label : option) === blankOptionLabel;
    var optionId = "".concat(id, "-select-options-").concat(index);
    var onSelection = function onSelection() {
      return onOptionSelection(option);
    };
    var onNestedSelection = function onNestedSelection(selected) {
      onOptionSelection(option, selected);
    };
    var isSelected;
    var selectionObj;
    if (hasNestedData) {
      var selectedValues = selection;
      var optionValues = optionValue.map(function (opt) {
        return _typeof(opt) === "object" ? opt.value : opt;
      });
      isSelected = (/* @__PURE__ */new Set([].concat(_toConsumableArray(selectedValues), _toConsumableArray(optionValues)))).size < selectedValues.length + optionValues.length;
    } else {
      isSelected = selection.includes(optionValue);
    }
    var selectOptionClasses = classnames("c-els-field__select-option", {
      "c-els-field__select-option--single-entry": !isMultiSelect
    }, {
      "c-els-field__select-option--selected": isSelected
    }, {
      "c-els-field__select-option--active": !hasNestedData && activeIndex === index
    }, {
      "c-els-field__select-option--nested": !!selectionObj
    }, {
      "c-els-field__select-option--first": index === 0
    }, {
      "c-els-field__select-option--last": index === filteredOptions.length - 1
    }, {
      "c-els-field__select-blank-option": isClearOption
    });
    var currentSelection = hasNestedData ? selection.filter(function (selectedOption) {
      return option.value.map(function (_ref4) {
        var value = _ref4.value;
        return value;
      }).includes(selectedOption);
    }) : selection;
    return isMultiSelect ? /* @__PURE__ */React.createElement("li", {
      key: optionId,
      "data-testid": optionId,
      className: selectOptionClasses
    }, hasNestedData ? /* @__PURE__ */React.createElement(TristateCheckbox, {
      label: optionLabel,
      id: optionId,
      options: optionValue,
      onChange: onNestedSelection,
      onFocus: function onFocus() {
        return setActiveIndex(index);
      },
      selectedOptions: currentSelection,
      shouldBeWrappedInFieldset: false,
      autoFocusParent: !(showSearch || showSelectAll) && index === 0
    }) : /* @__PURE__ */React.createElement(Checkbox, {
      checked: isSelected,
      label: optionLabel,
      id: optionId,
      onChange: onSelection,
      onFocus: function onFocus() {
        return setActiveIndex(index);
      },
      autoFocus: !(showSearch || showSelectAll) && index === 0
    })) :
    // SingleSelect option
    /* @__PURE__ */
    React.createElement("button", {
      id: optionId,
      "data-testid": optionId,
      className: "u-els-debuttonize ".concat(selectOptionClasses),
      onClick: onSelection,
      onMouseOver: function onMouseOver() {
        return setActiveIndex(index);
      },
      onFocus: function onFocus() {
        return setActiveIndex(index);
      },
      role: "option",
      "aria-selected": isSelected ? true : null,
      autoFocus:
      // If no search, focus selected, or first option if none selected
      !showSearch && (isSelected || selection.length === 0 && index === 0),
      type: "button",
      key: optionId
    }, /* @__PURE__ */React.createElement("span", {
      className: "c-els-field__select-option-text"
    }, optionLabel));
  })));
};
SelectOptions.displayName = "SelectOptions";
SelectOptions.propTypes = {
  /** Label for the blank option, */
  blankOptionLabel: string$4,
  /** Deselects all in multi or nested select */
  deselectAll: func$4,
  /** Id to be put onto various elements */
  id: string$4.isRequired,
  /** Determines if the select component is multiselect - this is false by default */
  isMultiSelect: bool$4,
  /** Determines if the select component is nestedselect - this is false by default */
  isNestedSelect: bool$4,
  /** Messages for internationalization */
  messages: object$2.isRequired,
  /** Options to be listed in the dropdown */
  options: arrayOf$3(oneOfType$2([string$4, number$2, shape$5({
    label: string$4.isRequired,
    value: oneOfType$2([string$4, number$2, array$2]).isRequired
  })])).isRequired,
  /** Selects all for Multi or Nested Select */
  selectAll: func$4,
  /** Item(s) selected from the select component. This must be managed by the consuming application */
  selection: arrayOf$3(oneOfType$2([string$4, number$2, shape$5({
    label: string$4,
    value: oneOfType$2([arrayOf$3(string$4), arrayOf$3(number$2)])
  })])).isRequired,
  /** Show search box at top of options panel */
  showSearch: bool$4,
  /** Show or hide the select/deselect all option */
  showSelectAll: bool$4,
  toggleDropdown: func$4.isRequired,
  /** unpacks nested options into a single list of values */
  unpackNestedOptions: func$4,
  /** Callback that accepts the value of the selected option as a parameter */
  onOptionSelection: func$4.isRequired
};
SelectOptions.requiredProps = {
  isMultiSelect: ValidPropTypes.BOOL,
  options: ValidPropTypes.ARRAY,
  onOptionSelection: ValidPropTypes.FUNCTION,
  selection: ValidPropTypes.ARRAY,
  toggleDropdown: ValidPropTypes.FUNCTION,
  id: ValidPropTypes.STRING
};
SelectOptions.defaultProps = {
  blankOptionLabel: "",
  selectAll: (/* istanbul ignore next */
  function selectAll() {
    return void 0;
  }),
  deselectAll: (/* istanbul ignore next */
  function deselectAll() {
    return void 0;
  }),
  isMultiSelect: false,
  isNestedSelect: false,
  showSearch: false,
  showSelectAll: false,
  unpackNestedOptions: (/* istanbul ignore next */
  function unpackNestedOptions() {
    return void 0;
  })
};
var RawSelectOptions = SelectOptions;
var SelectOptions$1 = makeErrorBoundComponent(RawSelectOptions);
var array$1 = PT.array,
  arrayOf$2 = PT.arrayOf,
  bool$3 = PT.bool,
  func$3 = PT.func,
  number$1 = PT.number,
  object$1 = PT.object,
  oneOfType$1 = PT.oneOfType,
  shape$4 = PT.shape,
  string$3 = PT.string;
var selectWrapper = function selectWrapper(WrappedComponent) {
  var displayName = WrappedComponent.displayName;
  var SelectWrapper = forwardRef(function (props, ref) {
    var className = props.className,
      options = props.options,
      placeholderText = props.placeholderText,
      isLabelInline = props.isLabelInline,
      selectedOptions = props.selectedOptions,
      hideSelectedOptions = props.hideSelectedOptions,
      isDisabled = props.isDisabled,
      isNestedSelect = props.isNestedSelect,
      isPlainInput = props.isPlainInput,
      isReadOnly = props.isReadOnly,
      shouldSelectionWrap = props.shouldSelectionWrap,
      showSearch = props.showSearch,
      size = props.size,
      id = props.id,
      blankOptionLabel = props.blankOptionLabel,
      onSelect = props.onSelect,
      label = props.label,
      messages = props.messages;
    var isMultiSelect = !!(displayName === "MultiSelect" || isNestedSelect);
    var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
    var _useState9 = useState(id || generateId()),
      _useState10 = _slicedToArray(_useState9, 1),
      selectId = _useState10[0];
    var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isDropdownOpen = _useState12[0],
      setIsDropdownOpen = _useState12[1];
    var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      selectionLabelState = _useState14[0],
      setSelectionLabelState = _useState14[1];
    var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      selectionState = _useState16[0],
      setSelectionState = _useState16[1];
    var _useState17 = useState(compiledMessages.CLEAR_MESSAGE),
      _useState18 = _slicedToArray(_useState17, 2),
      blankLabel = _useState18[0],
      setBlankLabel = _useState18[1];
    var _useState19 = useState({
        selectedOptions: [],
        options: [],
        blankOptionLabel: ""
      }),
      _useState20 = _slicedToArray(_useState19, 2),
      prevProps = _useState20[0],
      setPrevProps = _useState20[1];
    var prevIsDropdownOpenRef = useRef();
    var selectRef = useRef();
    checkRequiredProps(options, onSelect, label);
    useImperativeHandle(ref, function () {
      return {
        setSelectedOptions: function setSelectedOptions(newSelectedOptions) {
          setSelectionState(newSelectedOptions);
        },
        getSelectedOptions: function getSelectedOptions() {
          return selectionState;
        }
      };
    }, [selectionState]);
    var selectBlankOptionLabel = function selectBlankOptionLabel() {
      if (blankOptionLabel.length) {
        setBlankLabel(blankOptionLabel);
      } else if (placeholderText.length) {
        setBlankLabel(placeholderText);
      }
    };
    useEffect(function () {
      validateOptions(options, isMultiSelect, isNestedSelect);
      selectBlankOptionLabel();
    }, [options]);
    useEffect(function () {
      if (JSON.stringify(options) !== JSON.stringify(prevProps.options)) {
        setSelectionState([]);
        setSelectionLabelState([]);
      }
      if (JSON.stringify(selectedOptions) !== JSON.stringify(prevProps.selectedOptions)) {
        setSelectionState(selectedOptions);
      }
      if (isDropdownOpen && !prevIsDropdownOpenRef.current) {
        var listOptions = document.getElementsByClassName("c-els-field__select-options");
        listOptions.length && listOptions[0].focus();
      }
      if (!isDropdownOpen && prevIsDropdownOpenRef.current) {
        var selectInput = document.getElementById("".concat(selectId, "-select-input"));
        selectInput && selectInput.focus();
      }
      if (blankOptionLabel !== prevProps.blankOptionLabel) {
        selectBlankOptionLabel();
      }
      return function () {
        setPrevProps(_objectSpread(_objectSpread({}, prevProps), {}, {
          selectedOptions: selectedOptions,
          options: options,
          blankOptionLabel: blankOptionLabel
        }));
        prevIsDropdownOpenRef.current = isDropdownOpen;
      };
    }, [selectedOptions, options, blankOptionLabel, isDropdownOpen]);
    var handleDocumentClick = useCallback(function (event) {
      var _selectRef$current;
      event.target.getAttribute("data-testid") !== "select-clear-button" && !(selectRef !== null && selectRef !== void 0 && (_selectRef$current = selectRef.current) !== null && _selectRef$current !== void 0 && _selectRef$current.contains(event.target)) && (document.removeEventListener("click", handleDocumentClick), setIsDropdownOpen(false));
    }, []);
    var openDropdown = function openDropdown() {
      document.addEventListener("click", handleDocumentClick);
      setIsDropdownOpen(true);
    };
    var closeDropdown = function closeDropdown() {
      document.removeEventListener("click", handleDocumentClick);
      setIsDropdownOpen(false);
    };
    var toggleDropdown = function toggleDropdown() {
      if (!isDropdownOpen) {
        openDropdown();
      } else {
        closeDropdown();
      }
    };
    var selectInputKeyDown = function selectInputKeyDown(event) {
      switch (event.key) {
        case " ":
        case "Enter":
          event.preventDefault();
          toggleDropdown();
          break;
        case "ArrowDown":
          event.preventDefault();
          openDropdown();
          break;
        case "Escape":
          event.preventDefault();
          closeDropdown();
          break;
      }
    };
    var isDisabledOrReadOnly = isDisabled || isReadOnly;
    var getComponentClasses = function getComponentClasses(currentState) {
      return generateClasses(className, shouldSelectionWrap, isDropdownOpen, size, isReadOnly, isDisabledOrReadOnly, isLabelInline, currentState.selectionState, currentState.validity, isPlainInput, hideSelectedOptions);
    };
    var iconToUse = isDropdownOpen ? Icon.Sprites.CHEVRON_UP : Icon.Sprites.CHEVRON_DOWN;
    return /* @__PURE__ */React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      blankOptionLabel: blankLabel,
      getComponentClasses: getComponentClasses,
      iconToUse: iconToUse,
      id: selectId,
      isDropdownOpen: isDropdownOpen,
      isPlainInput: isPlainInput,
      selectRef: selectRef,
      selectionLabel: selectionLabelState,
      selectedOptions: selectionState,
      showSearch: showSearch,
      toggleDropdown: toggleDropdown,
      selectInputKeyDown: selectInputKeyDown
    }));
  });
  SelectWrapper.displayName = "Main".concat(displayName);
  SelectWrapper.propTypes = {
    /** Label for the blank option, */
    blankOptionLabel: string$3,
    /** Allow custom classes for outward-looking styling (margins, width) of the component */
    className: string$3,
    /**
     * Object used to override the default error messages for the included validators
     * @property {string} errorMessageMap.required - error message for an empty required field
     */
    errorMessageMap: shape$4({
      required: string$3
    }),
    /** Hides the required asterisk; used in InputDatePicker */
    hideRequired: bool$3,
    /** Don't show the select options/select input */
    hideSelectedOptions: bool$3,
    /** Id to be put onto various elements */
    id: string$3,
    /** A React ref applied to the input element */
    inputRef: object$1,
    /** Determines if the select component should be disabled - this is false by default */
    isDisabled: bool$3,
    /** Determines if the label should be to the left of the input (true) or above it (false) */
    isLabelInline: bool$3,
    isNestedSelect: bool$3,
    /** Removes border from field input */
    isPlainInput: bool$3,
    /** Determines if the select component should be disabled and displayed as read only - this is false by default */
    isReadOnly: bool$3,
    /** Label to be place above the input */
    label: string$3.isRequired,
    /** Messages for internationalization */
    messages: object$1,
    /** Options to be listed in the dropdown */
    options: arrayOf$2(oneOfType$1([string$3, number$1, shape$4({
      label: string$3.isRequired,
      value: oneOfType$1([string$3, number$1, array$1]).isRequired
    })])).isRequired,
    /** Any prop supported by Flyout */
    optionsFlyoutProps: object$1,
    /** placeholder text for the input if nothing has been selected */
    placeholderText: string$3,
    /** An input value exists after the user changes the value */
    required: bool$3,
    /** An override for the hidden text denoting a required field */
    requiredLabel: string$3,
    /** selectedOptions array for pre-selecting values */
    selectedOptions: arrayOf$2(oneOfType$1([string$3, number$1, shape$4({
      label: string$3.isRequired,
      value: oneOfType$1([string$3, number$1, array$1, shape$4({})])
    })])),
    /** Controls whether or not to hide the error message */
    shouldHideErrorMessage: bool$3,
    /** Determines if the label is shown or not */
    shouldHideLabel: bool$3,
    /** Determines if select component should wrap content - this is false by default */
    shouldSelectionWrap: bool$3,
    /** Show search box at top of options panel */
    showSearch: bool$3,
    /** Multiselect prop for showing select all functionality. Listed in selectWrapper proptypes so default is shown in docs */
    showSelectAll: bool$3,
    /** Multiselect prop for showing selection count. Listed in selectWrapper proptypes so default is shown in docs */
    showSelectCount: bool$3,
    /** Set size of input */
    size: string$3,
    /** callback to update the selection if an option is selected */
    onSelect: func$3.isRequired
  };
  SelectWrapper.requiredProps = {
    options: ValidPropTypes.ARRAY,
    label: ValidPropTypes.STRING,
    onSelect: ValidPropTypes.FUNCTION
  };
  SelectWrapper.defaultProps = {
    blankOptionLabel: "",
    className: "",
    errorMessageMap: {},
    hideRequired: false,
    hideSelectedOptions: false,
    id: null,
    inputRef: null,
    isDisabled: false,
    isLabelInline: false,
    isNestedSelect: false,
    isReadOnly: false,
    isPlainInput: false,
    messages: DefaultMessages,
    optionsFlyoutProps: {},
    placeholderText: "",
    required: false,
    requiredLabel: "Required",
    selectedOptions: [],
    shouldHideErrorMessage: false,
    shouldHideLabel: false,
    showSearch: false,
    showSelectAll: false,
    showSelectCount: true,
    shouldSelectionWrap: false,
    size: null
  };
  SelectWrapper.Sizes = SelectSizes;
  SelectWrapper.DefaultMessages = DefaultMessages;
  return makeErrorBoundComponent(SelectWrapper);
};
var func$2 = PT.func,
  shape$3 = PT.shape;
var withValidation = function withValidation(WrappedComponent) {
  var displayName = WrappedComponent.displayName;
  var ValidatedSelect = forwardRef(function (props, ref) {
    var onSelect = props.onSelect,
      validator = props.validator,
      onMountValidation = props.onMountValidation,
      selectedOptions = props.selectedOptions,
      propsToValidate = props.propsToValidate,
      className = props.className,
      selectProps = _objectWithoutProperties(props, _excluded);
    var _useState21 = useState({}),
      _useState22 = _slicedToArray(_useState21, 2),
      errorMessages = _useState22[0],
      setErrorMessages = _useState22[1];
    var validate = function validate(value) {
      var errorMessage = validator(value);
      var isValid = !errorMessage;
      setErrorMessages({
        customValidity: isValid ? null : errorMessage
      });
      return isValid;
    };
    useEffect(function () {
      var validity = validate(selectedOptions);
      if (onMountValidation) {
        onMountValidation(validity);
      }
    }, [selectedOptions, onMountValidation, propsToValidate]);
    useEffect(function () {}, []);
    var handleSelect = function handleSelect(selectedValue) {
      var option = [];
      if (displayName.includes("NestedSelect") || displayName.includes("MultiSelect")) {
        option = selectedValue.every(function (data) {
          return _typeof(data) === "object";
        }) ? selectedValue.map(function (data) {
          return data.value;
        }) : selectedValue;
      } else {
        option = /* istanbul ignore next */
        _typeof(selectedValue) === "object" ? [selectedValue.value] : [selectedValue];
      }
      var validity = validate(option);
      if (onSelect) {
        onSelect(selectedValue, validity);
      }
    };
    var ariaId = selectProps.id || generateId();
    var classes = classnames(className, {
      // eslint-disable-next-line prettier/prettier
      "select-input--invalid c-els-field--error c-els-field--error__label": errorMessages.customValidity
    });
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      className: classes,
      id: ariaId,
      "data-testid": ariaId,
      ariaDescribedby: "".concat(ariaId, "-message"),
      onSelect: handleSelect
    })), errorMessages.customValidity && /* @__PURE__ */React.createElement(ValidatedTextInput.Message, {
      id: "".concat(ariaId, "-message"),
      type: ValidatedTextInput.Message.Types.ERROR,
      "data-testid": "".concat(ariaId, "-message")
    }, errorMessages.customValidity));
  });
  ValidatedSelect.displayName = "Validated".concat(displayName);
  ValidatedSelect.propTypes = _objectSpread(_objectSpread({}, selectWrapper.propTypes), {}, {
    /** an object containing any variable the consuming application can pass that will cause the validation to run again if changed */
    propsToValidate: shape$3({}),
    /** custom validation function */
    validator: func$2.isRequired,
    /** onMountValidation function returns validity and validates the option on mount */
    onMountValidation: func$2
  });
  ValidatedSelect.defaultProps = _objectSpread(_objectSpread({}, selectWrapper.defaultProps), {}, {
    onMountValidation: null,
    selectedOptions: [],
    propsToValidate: null
  });
  ValidatedSelect.requiredProps = {
    options: ValidPropTypes.ARRAY,
    label: ValidPropTypes.STRING,
    onSelect: ValidPropTypes.FUNCTION,
    validator: ValidPropTypes.FUNCTION
  };
  ValidatedSelect.DefaultMessages = DefaultMessages;
  return ValidatedSelect;
};
var bool$2 = PT.bool,
  func$1 = PT.func,
  shape$2 = PT.shape,
  string$2 = PT.string;
var MultiSelect = function MultiSelect(_ref5) {
  var blankOptionLabel = _ref5.blankOptionLabel,
    getComponentClasses = _ref5.getComponentClasses,
    iconToUse = _ref5.iconToUse,
    id = _ref5.id,
    inputRef = _ref5.inputRef,
    isDisabled = _ref5.isDisabled,
    isDropdownOpen = _ref5.isDropdownOpen,
    isNestedSelect = _ref5.isNestedSelect,
    isReadOnly = _ref5.isReadOnly,
    label = _ref5.label,
    messages = _ref5.messages,
    onSelect = _ref5.onSelect,
    options = _ref5.options,
    optionsFlyoutProps = _ref5.optionsFlyoutProps,
    placeholderText = _ref5.placeholderText,
    required = _ref5.required,
    requiredLabel = _ref5.requiredLabel,
    selectedOptions = _ref5.selectedOptions,
    selectInputKeyDown = _ref5.selectInputKeyDown,
    selectRef = _ref5.selectRef,
    shouldHideErrorMessage = _ref5.shouldHideErrorMessage,
    shouldHideLabel = _ref5.shouldHideLabel,
    shouldSelectionWrap = _ref5.shouldSelectionWrap,
    showSearch = _ref5.showSearch,
    showSelectAll = _ref5.showSelectAll,
    showSelectCount = _ref5.showSelectCount,
    toggleDropdown = _ref5.toggleDropdown;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    selectionState = _useState24[0],
    setSelectionState = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    selectionLabelState = _useState26[0],
    setSelectionLabelState = _useState26[1];
  var _useState27 = useState(ValidationModes.NEUTRAL),
    _useState28 = _slicedToArray(_useState27, 2),
    validity = _useState28[0],
    setValidity = _useState28[1];
  var _useState29 = useState({
      selectedOptions: []
    }),
    _useState30 = _slicedToArray(_useState29, 2),
    prevProps = _useState30[0],
    setPrevProps = _useState30[1];
  var _useState31 = useState({}),
    _useState32 = _slicedToArray(_useState31, 2),
    errorMessages = _useState32[0],
    setErrorMessages = _useState32[1];
  var selectInputRef = inputRef || createRef();
  var errorMessage = errorMessages.required;
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2),
    selectionCount = _useState34[0],
    setSelectionCount = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    optionValues = _useState36[0],
    setOptionValues = _useState36[1];
  var getFlatValueArray = function getFlatValueArray() {
    var flatValueArray = options.reduce(function (acc, curr) {
      if (Array.isArray(curr.value)) {
        var valueMap = curr.value.map(function (_ref6) {
          var value = _ref6.value;
          return value;
        });
        return [].concat(_toConsumableArray(acc), _toConsumableArray(valueMap));
      }
      return [].concat(_toConsumableArray(acc), [curr]);
    }, []);
    if (new Set(flatValueArray).size !== flatValueArray.length) {
      throw new Error("All values must be unique");
    }
    return flatValueArray;
  };
  useEffect(function () {
    setSelection(selectedOptions);
    if (isNestedSelect) {
      var newOptionValues = getFlatValueArray();
      setOptionValues(newOptionValues);
    }
  }, []);
  useEffect(function () {
    if (isNestedSelect) {
      var newOptionValues = getFlatValueArray();
      setOptionValues(newOptionValues);
    }
  }, [options]);
  useEffect(function () {
    JSON.stringify(selectedOptions) !== JSON.stringify(prevProps.selectedOptions) &&
    // eslint-disable-next-line no-use-before-define
    setSelection(selectedOptions);
    return function () {
      setPrevProps(_objectSpread(_objectSpread({}, prevProps), {}, {
        selectedOptions: selectedOptions
      }));
    };
  }, [selectedOptions]);
  var checkForSelectedOptions = function checkForSelectedOptions(selectedOptionsParam, optionsParam) {
    if (isNestedSelect) {
      return selectedOptionsParam.every(function (option) {
        return optionValues.includes(option);
      });
    }
    var optionValuesInner = optionsParam.map(function (option) {
      return _typeof(option) === "object" ? option.value : option;
    });
    var isSelectedOptionNotFound = selectedOptionsParam.some(function (selectedOption) {
      return !optionValuesInner.includes(selectedOption);
    });
    return !isSelectedOptionNotFound;
  };
  var setSelection = function setSelection(selection) {
    var selectionLabel = [];
    var newSelectionCount = 0;
    validateSelectedOptions(selectedOptions, true, options, checkForSelectedOptions, isNestedSelect);
    if (isNestedSelect) {
      selectionLabel = options.reduce(function (acc, option) {
        if (_typeof(option) === "object") {
          var optionValuesMap = option.value.map(function (_ref7) {
            var value = _ref7.value;
            return value;
          });
          var selectedOptionValues = optionValuesMap.filter(function (optionValue) {
            return selection.includes(optionValue);
          });
          newSelectionCount += selectedOptionValues.length;
          return selectedOptionValues.length ? [].concat(_toConsumableArray(acc), ["".concat(option.label, " (").concat(selectedOptionValues.length, ")")]) : acc;
        }
        return selection.includes(option) ? [].concat(_toConsumableArray(acc), [option]) : acc;
      }, []);
      setSelectionState(selection);
      setSelectionLabelState(selectionLabel);
      setSelectionCount(newSelectionCount);
      return selection;
    }
    var selectionObjectOptions = selection.reduce(function (selOptions, selectedOption) {
      var filteredOptions = options.reduce(function (opts, option) {
        var newOptions = _toConsumableArray(opts);
        var optionValue = _typeof(option) === "object" ? option.value : option;
        var selectedOptionIsEqual = optionValue === selectedOption;
        if (selectedOptionIsEqual) {
          newSelectionCount += 1;
          newOptions.push(option);
        }
        return newOptions;
      }, []);
      return [].concat(_toConsumableArray(selOptions), _toConsumableArray(filteredOptions));
    }, []);
    selectionLabel = selectionObjectOptions.map(function (option) {
      var labelSelection = option;
      if (_typeof(option) === "object") {
        var optionLabel = option.label;
        labelSelection = optionLabel;
      }
      return labelSelection;
    });
    setSelectionState(selection);
    setSelectionLabelState(selectionLabel);
    setSelectionCount(newSelectionCount);
    return selectionObjectOptions;
  };
  var validateRequiredLength = function validateRequiredLength(value) {
    var validityInner = ValidationModes.VALID;
    if (value === 0) {
      validityInner = required ? ValidationModes.INVALID : ValidationModes.NEUTRAL;
    }
    return validityInner;
  };
  var validate = function validate(selectedOpts) {
    var selectedOptionsLength = selectedOpts.length;
    var requiredErrorMessage = compiledMessages.ONE_OPTION_REQUIRED_MESSAGE;
    var requiredValidity = validateRequiredLength(selectedOptionsLength);
    setErrorMessages({
      required: requiredValidity === ValidationModes.INVALID ? requiredErrorMessage : null
    });
    setValidity(requiredValidity);
  };
  var onSelection = function onSelection(option, nestedSelection) {
    var newSelection = [];
    var optionsToReturn = [];
    if (isNestedSelect) {
      var mappedOptionValue = option.value.map(function (_ref8) {
        var value = _ref8.value;
        return value;
      });
      var filteredValues = selectionState.filter(function (curr) {
        return !mappedOptionValue.includes(curr);
      });
      newSelection = [].concat(_toConsumableArray(filteredValues), _toConsumableArray(nestedSelection));
      setSelection(newSelection);
      optionsToReturn = newSelection.reduce(function (acc, selectedOption) {
        var valueToReturn;
        options.forEach(function (currentOption) {
          currentOption.value.forEach(function (currentOptionValue) {
            if (_typeof(currentOptionValue) === "object" && currentOptionValue.value === selectedOption) {
              valueToReturn = currentOptionValue;
            }
          });
        });
        return [].concat(_toConsumableArray(acc), [valueToReturn]);
      }, []);
    } else {
      var optionValue = _typeof(option) === "object" ? option.value : option;
      if (selectionState.includes(optionValue)) {
        newSelection = selectionState.filter(function (item) {
          return item !== optionValue;
        });
      } else {
        newSelection = [].concat(_toConsumableArray(selectionState), [optionValue]);
      }
      optionsToReturn = setSelection(newSelection);
    }
    validate(newSelection);
    onSelect(optionsToReturn);
  };
  var unpackNestedOptions = function unpackNestedOptions(nestedOptions) {
    var unpackedOptions = [];
    nestedOptions.forEach(function (option) {
      var mappedOptionValue = option.value.map(function (_ref9) {
        var value = _ref9.value;
        return value;
      });
      unpackedOptions = [].concat(_toConsumableArray(unpackedOptions), _toConsumableArray(mappedOptionValue));
    });
    return unpackedOptions;
  };
  var selectAll = function selectAll(relevantOptions) {
    var newSelection = [];
    var optionsToReturn = [];
    if (isNestedSelect) {
      newSelection = unpackNestedOptions(relevantOptions);
      setSelection(newSelection);
      optionsToReturn = newSelection.reduce(function (acc, selectedOption) {
        var valueToReturn;
        relevantOptions.forEach(function (currentOption) {
          currentOption.value.forEach(function (currentOptionValue) {
            if (_typeof(currentOptionValue) === "object" && currentOptionValue.value === selectedOption) {
              valueToReturn = currentOptionValue;
            }
          });
        });
        return [].concat(_toConsumableArray(acc), [valueToReturn]);
      }, []);
    } else {
      newSelection = relevantOptions.every(function (optionItem) {
        return _typeof(optionItem) === "object";
      }) ? relevantOptions.map(function (optionDatum) {
        return optionDatum.value;
      }) : relevantOptions;
      optionsToReturn = setSelection(newSelection);
    }
    validate(newSelection);
    onSelect(optionsToReturn);
  };
  var getValues = function getValues(relevantOptions) {
    return relevantOptions.map(function (option) {
      return _typeof(option) === "object" ? option.value : option;
    });
  };
  var deselectAll = function deselectAll(selection, relevantOptions) {
    var optionsAsValueArray = isNestedSelect ? unpackNestedOptions(relevantOptions) : getValues(relevantOptions);
    var newSelection = selection.reduce(function (acc, curr) {
      if (!optionsAsValueArray.includes(curr)) {
        return [].concat(_toConsumableArray(acc), [curr]);
      }
      return acc;
    }, []);
    validate(newSelection);
    onSelect(setSelection(newSelection));
  };
  var isDisabledOrReadOnly = isDisabled || isReadOnly;
  var _getComponentClasses = getComponentClasses({
      validity: validity,
      selectionState: selectionState
    }),
    wrapperClasses = _getComponentClasses.wrapperClasses,
    iconClasses = _getComponentClasses.iconClasses,
    inputClasses = _getComponentClasses.inputClasses;
  var selectCountClasses = classnames({
    "c-els-field--hide-selected-options-show-count": showSelectCount && selectionCount > 0,
    "c-els-field--selected-options-two-digit-count": showSelectCount && selectionCount > 9,
    "c-els-field--selected-options-three-digit-count": showSelectCount && selectionCount > 99,
    "c-els-field--selected-options-four-digit-count": showSelectCount && selectionCount > 999
  });
  var textToDisplay = selectionLabelState.join(", ") || "";
  var ElementComponent = shouldSelectionWrap ? "div" : TextInput;
  var elementComponentProps = shouldSelectionWrap ? {} : {
    isSelectBox: true,
    shouldHideLabel: shouldHideLabel,
    requiredLabel: requiredLabel
  };
  return /* @__PURE__ */React.createElement("div", {
    ref: selectRef,
    className: wrapperClasses,
    id: "".concat(id, "-select-wrapper"),
    "data-testid": "select-wrapper"
  }, /* @__PURE__ */React.createElement(Flyout, _objectSpread({
    flyout: /* @__PURE__ */React.createElement(SelectOptions$1, {
      blankOptionLabel: blankOptionLabel,
      "data-testid": "select-options",
      deselectAll: deselectAll,
      id: id,
      isMultiSelect: true,
      isNestedSelect: isNestedSelect,
      messages: compiledMessages,
      onOptionSelection: onSelection,
      options: _toConsumableArray(options),
      selectAll: selectAll,
      selectInputRef: selectInputRef,
      selection: selectionState,
      setSelectionMultiSelect: setSelection,
      showSearch: showSearch,
      showSelectAll: showSelectAll,
      toggleDropdown: toggleDropdown,
      unpackNestedOptions: unpackNestedOptions,
      validateMultiSelect: validate
    }),
    placement: "bottom-start",
    theme: "minimal",
    pointerType: "primary",
    pointer: false,
    isDisabled: isDisabledOrReadOnly,
    isControlled: true,
    isOpen: isDropdownOpen,
    className: "c-els-flyout--display-block c-els-field__select-flyout"
  }, optionsFlyoutProps), /* @__PURE__ */React.createElement(React.Fragment, null, shouldSelectionWrap && /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__label ".concat(shouldHideLabel && "u-els-hide-visually")
  }, /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__label-text",
    id: "".concat(id, "-select-label"),
    "data-testid": "select-label"
  }, required && /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__label-required-indicator"
  }, "*", /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, "(", requiredLabel, ")")), label)), /* @__PURE__ */React.createElement(ElementComponent, _objectSpread({
    label: label,
    className: "".concat(inputClasses, " ").concat(selectCountClasses),
    value: textToDisplay,
    placeholder: placeholderText,
    id: "".concat(id, "-select-input"),
    "data-testid": "select-input",
    onKeyDown: isDisabledOrReadOnly ? null : selectInputKeyDown,
    onClick: isDisabledOrReadOnly ? null : toggleDropdown,
    "aria-controls": "".concat(id, "-select-options-wrapper"),
    "aria-expanded": isDropdownOpen,
    "aria-labelledby": shouldSelectionWrap ? "".concat(id, "-select-label") : null,
    "aria-haspopup": "listbox",
    role: "combobox",
    tabIndex: shouldSelectionWrap ? 0 : null,
    readOnly: true,
    required: required,
    ref: shouldSelectionWrap ? selectInputRef : null,
    inputRef: !shouldSelectionWrap ? selectInputRef : null
  }, elementComponentProps), /* @__PURE__ */React.createElement(React.Fragment, null, shouldSelectionWrap &&
  // eslint-disable-next-line react/jsx-no-useless-fragment
  /* @__PURE__ */
  React.createElement(React.Fragment, null, textToDisplay || placeholderText), showSelectCount && selectionCount > 0 && /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__secondary-icon-right",
    "data-testid": "select-count"
  }, /* @__PURE__ */React.createElement("span", {
    className: "c-els-pill c-els-pill--condensed u-els-background-color-n3 u-els-color-text"
  }, selectionCount, /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, " ", compiledMessages.ITEMS_SELECTED))), !isDisabledOrReadOnly && /* @__PURE__ */React.createElement(Icon, {
    className: iconClasses,
    isDecorative: true,
    sprite: iconToUse,
    size: "s",
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "▼";
    })
  }))))), !isDropdownOpen && !shouldHideErrorMessage && errorMessage && /* @__PURE__ */React.createElement(ValidatedTextInput.Message, {
    type: ValidatedTextInput.Message.Types.ERROR
  }, errorMessage));
};
MultiSelect.displayName = "MultiSelect";
MultiSelect.propTypes = _objectSpread(_objectSpread({}, selectWrapper.propTypes), {}, {
  getComponentClasses: func$1,
  iconToUse: string$2,
  isDropdownOpen: bool$2,
  isNestedSelect: bool$2,
  /** Callback to pass keyboard event to the parent component */
  selectInputKeyDown: func$1.isRequired,
  /** A ref for the select input */
  selectRef: shape$2({
    current: PT.object
  }).isRequired,
  toggleDropdown: func$1
});
MultiSelect.requiredProps = {
  id: ValidPropTypes.STRING,
  options: ValidPropTypes.ARRAY,
  label: ValidPropTypes.STRING,
  selectInputKeyDown: ValidPropTypes.FUNCTION,
  onSelect: ValidPropTypes.FUNCTION
};
MultiSelect.defaultProps = _objectSpread(_objectSpread({}, selectWrapper.defaultProps), {}, {
  iconToUse: Icon.Sprites.CHEVRON_DOWN,
  toggleDropdown: (/* istanbul ignore next */
  function toggleDropdown() {
    return void 0;
  }),
  isDropdownOpen: false,
  isNestedSelect: false,
  getComponentClasses: (/* istanbul ignore next */
  function getComponentClasses() {})
});
MultiSelect.Sizes = SelectSizes;
var RawMultiSelect = MultiSelect;
var ValidatedMultiSelect = withValidation(selectWrapper(MultiSelect));
var MultiSelect$1 = selectWrapper(RawMultiSelect);
var array = PT.array,
  arrayOf$1 = PT.arrayOf,
  bool$1 = PT.bool,
  number = PT.number,
  object = PT.object,
  oneOfType = PT.oneOfType,
  shape$1 = PT.shape,
  string$1 = PT.string;
var NestedSelect = forwardRef(function (props, ref) {
  return /* @__PURE__ */React.createElement(MultiSelect$1, _objectSpread(_objectSpread({
    isNestedSelect: true
  }, props), {}, {
    ref: ref
  }));
});
NestedSelect.displayName = "NestedSelect";
NestedSelect.propTypes = _objectSpread(_objectSpread({}, selectWrapper.propTypes), {}, {
  iconToUse: string$1,
  isDropdownOpen: bool$1,
  /** Options to be listed in the dropdown */
  options: arrayOf$1(oneOfType([string$1, number, shape$1({
    label: string$1.isRequired,
    value: oneOfType([string$1, number, array, object]).isRequired
  })])).isRequired,
  /** selectedOptions array for pre-selecting values */
  selectedOptions: arrayOf$1(oneOfType([string$1, number, shape$1({
    label: string$1.isRequired,
    value: oneOfType([string$1, number, array, object])
  })]))
});
NestedSelect.requiredProps = {
  id: ValidPropTypes.STRING,
  options: ValidPropTypes.ARRAY,
  label: ValidPropTypes.STRING,
  onSelect: ValidPropTypes.FUNCTION
};
NestedSelect.defaultProps = _objectSpread(_objectSpread({}, selectWrapper.defaultProps), {}, {
  iconToUse: Icon.Sprites.CHEVRON_DOWN,
  isDropdownOpen: false
});
NestedSelect.Sizes = SelectSizes;
var RawNestedSelect = NestedSelect;
var ValidatedNestedSelect = withValidation(NestedSelect);
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  shape = PT.shape,
  string = PT.string;
var SingleSelect = function SingleSelect(_ref10) {
  var blankOptionLabel = _ref10.blankOptionLabel,
    iconToUse = _ref10.iconToUse,
    id = _ref10.id,
    inputRef = _ref10.inputRef,
    isDisabled = _ref10.isDisabled,
    isDropdownOpen = _ref10.isDropdownOpen,
    isReadOnly = _ref10.isReadOnly,
    label = _ref10.label,
    getComponentClasses = _ref10.getComponentClasses,
    hideRequired = _ref10.hideRequired,
    messages = _ref10.messages,
    onSelect = _ref10.onSelect,
    optionsFlyoutProps = _ref10.optionsFlyoutProps,
    options = _ref10.options,
    placeholderText = _ref10.placeholderText,
    required = _ref10.required,
    requiredLabel = _ref10.requiredLabel,
    selectedOptions = _ref10.selectedOptions,
    selectInputKeyDown = _ref10.selectInputKeyDown,
    selectionLabel = _ref10.selectionLabel,
    selectRef = _ref10.selectRef,
    shouldHideLabel = _ref10.shouldHideLabel,
    shouldSelectionWrap = _ref10.shouldSelectionWrap,
    showSearch = _ref10.showSearch,
    toggleDropdown = _ref10.toggleDropdown;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    selectionState = _useState38[0],
    setSelectionState = _useState38[1];
  var _useState39 = useState(selectionLabel),
    _useState40 = _slicedToArray(_useState39, 2),
    selectionLabelState = _useState40[0],
    setSelectionLabelState = _useState40[1];
  var selectInputRef = inputRef || createRef();
  useEffect(function () {
    setSelection(selectedOptions);
  }, [selectedOptions]);
  var checkForSelectedOptions = function checkForSelectedOptions(selectedOptionsParam, optionsParam) {
    var optionValues = optionsParam.map(function (option) {
      return _typeof(option) === "object" ? option.value : option;
    });
    var isSelectedOptionNotFound = selectedOptionsParam.some(function (selectedOption) {
      return !optionValues.includes(selectedOption);
    });
    return !isSelectedOptionNotFound;
  };
  var formatBlankOption = function formatBlankOption() {
    var blankOptionOption = options.every(function (option) {
      return _typeof(option) === "object";
    }) ? {
      label: blankOptionLabel,
      value: ""
    } : blankOptionLabel;
    return [blankOptionOption];
  };
  var addAdditionalOptions = function addAdditionalOptions() {
    var blankOptionOption = !required ? formatBlankOption() : [];
    return [].concat(_toConsumableArray(blankOptionOption), _toConsumableArray(options));
  };
  var setSelection = function setSelection(selectedValueOptions) {
    var optionsSelection = addAdditionalOptions();
    if (selectedValueOptions && selectedValueOptions.length === 1 && (selectedValueOptions[0] === blankOptionLabel ||
    // Selected value can be blank string for value/label options
    selectedValueOptions[0] === "")) {
      setSelectionState([]);
      setSelectionLabelState([]);
      return [""];
    }
    validateSelectedOptions(selectedValueOptions, false, optionsSelection, checkForSelectedOptions);
    var selectionObjectOptions = selectedValueOptions.reduce(function (selOptions, selectedOption) {
      var filteredOptions = optionsSelection.reduce(function (opts, option) {
        var newOptions = _toConsumableArray(opts);
        var optionValue = _typeof(option) === "object" ? option.value : option;
        var selectedOptionIsEqual = optionValue === selectedOption;
        if (selectedOptionIsEqual) {
          newOptions.push(option);
        }
        return newOptions;
      }, []);
      return [].concat(_toConsumableArray(selOptions), _toConsumableArray(filteredOptions));
    }, []);
    var selectionLabelSt = selectionObjectOptions.map(function (option) {
      var labelValue = option;
      if (_typeof(option) === "object") {
        var optionLabel = option.label;
        labelValue = optionLabel;
      }
      return labelValue;
    });
    setSelectionState(selectedValueOptions);
    setSelectionLabelState(selectionLabelSt);
    return selectionObjectOptions;
  };
  var _useState41 = useState([]),
    _useState42 = _slicedToArray(_useState41, 2),
    tempSelection = _useState42[0],
    setTempSelection = _useState42[1];
  var onSelection = function onSelection(option) {
    var keepDropdownOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var optionValue = _typeof(option) === "object" ? option.value : option;
    var selectionObjectOptions = setSelection([optionValue]);
    setTempSelection(selectionObjectOptions);
    if (!keepDropdownOpen) {
      toggleDropdown();
    }
  };
  useEffect(function () {
    if (!isDropdownOpen && tempSelection.length) {
      onSelect(tempSelection[0]);
    }
  }, [isDropdownOpen, tempSelection]);
  useEffect(function () {
    setTempSelection([]);
  }, [options]);
  var isDisabledOrReadOnly = isDisabled || isReadOnly;
  var _getComponentClasses2 = getComponentClasses({
      selectionState: selectionState
    }),
    wrapperClasses = _getComponentClasses2.wrapperClasses,
    iconClasses = _getComponentClasses2.iconClasses,
    inputClasses = _getComponentClasses2.inputClasses;
  var textToDisplay = selectionLabelState.length ? selectionLabelState : "";
  var ElementComponent = shouldSelectionWrap ? "div" : TextInput;
  var elementComponentProps = shouldSelectionWrap ? {} : {
    isSelectBox: true,
    shouldHideLabel: shouldHideLabel,
    requiredLabel: requiredLabel
  };
  return /* @__PURE__ */React.createElement("div", {
    ref: selectRef,
    className: wrapperClasses,
    id: "".concat(id, "-select-wrapper"),
    "data-testid": "select-wrapper"
  }, /* @__PURE__ */React.createElement(Flyout, _objectSpread({
    flyout: /* @__PURE__ */React.createElement(SelectOptions$1, {
      blankOptionLabel: blankOptionLabel,
      "data-testid": "select-options",
      id: id,
      messages: compiledMessages,
      onOptionSelection: onSelection,
      options: addAdditionalOptions(),
      selectInputRef: selectInputRef,
      selection: selectionState,
      showSearch: showSearch,
      toggleDropdown: toggleDropdown
    }),
    placement: "bottom-start",
    theme: "minimal",
    pointerType: "primary",
    pointer: false,
    isDisabled: isDisabledOrReadOnly,
    isControlled: true,
    isOpen: isDropdownOpen,
    className: "c-els-flyout--display-block c-els-field__select-flyout"
  }, optionsFlyoutProps), /* @__PURE__ */React.createElement(React.Fragment, null, shouldSelectionWrap && /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__label ".concat(shouldHideLabel && "u-els-hide-visually")
  }, /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__label-text",
    id: "select-label"
  }, required && /* @__PURE__ */React.createElement("span", {
    className: !hideRequired && "c-els-field__label-required-indicator"
  }, !hideRequired && /* @__PURE__ */React.createElement(React.Fragment, null, "*"), /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, "(", requiredLabel, ")")), label)), /* @__PURE__ */React.createElement(ElementComponent, _objectSpread({
    label: label,
    className: inputClasses,
    value: textToDisplay,
    placeholder: placeholderText,
    id: "".concat(id, "-select-input"),
    "data-testid": "select-input",
    onKeyDown: isDisabledOrReadOnly ? null : selectInputKeyDown,
    onClick: isDisabledOrReadOnly ? null : toggleDropdown,
    "aria-controls": "".concat(id, "-select-options-wrapper"),
    "aria-expanded": isDropdownOpen,
    "aria-labelledby": shouldSelectionWrap ? "".concat(id, "-select-label") : null,
    "aria-haspopup": "listbox",
    role: "combobox",
    tabIndex: shouldSelectionWrap ? 0 : null,
    readOnly: true,
    required: required,
    hideRequired: hideRequired,
    ref: shouldSelectionWrap ? selectInputRef : null,
    inputRef: !shouldSelectionWrap ? selectInputRef : null
  }, elementComponentProps), /* @__PURE__ */React.createElement(React.Fragment, null, shouldSelectionWrap &&
  // eslint-disable-next-line react/jsx-no-useless-fragment
  /* @__PURE__ */
  React.createElement("span", {
    "data-testid": "select-input-value",
    className: "c-els-field__wrapped-input-value"
  }, textToDisplay || placeholderText), !isDisabledOrReadOnly && /* @__PURE__ */React.createElement(Icon, {
    className: iconClasses,
    isDecorative: true,
    sprite: iconToUse,
    size: "s",
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "▼";
    })
  }))))));
};
SingleSelect.displayName = "SingleSelect";
SingleSelect.propTypes = _objectSpread(_objectSpread({}, selectWrapper.propTypes), {}, {
  getComponentClasses: func,
  /** Hides the required asterisk; used in InputDatePicker */
  hideRequired: bool,
  iconToUse: string,
  isDropdownOpen: bool,
  /** Callback to pass keyboard event to the parent component */
  selectInputKeyDown: func.isRequired,
  selectionLabel: arrayOf(string),
  /** A ref for the select input */
  selectRef: shape({
    current: PT.object
  }).isRequired,
  toggleDropdown: func
});
SingleSelect.requiredProps = {
  id: ValidPropTypes.STRING,
  label: ValidPropTypes.STRING,
  options: ValidPropTypes.ARRAY,
  selectInputKeyDown: ValidPropTypes.FUNCTION,
  onSelect: ValidPropTypes.FUNCTION
};
SingleSelect.defaultProps = _objectSpread(_objectSpread({}, selectWrapper.defaultProps), {}, {
  hideRequired: false,
  toggleDropdown: (/* istanbul ignore next */
  function toggleDropdown() {
    return void 0;
  }),
  isDropdownOpen: false,
  selectionLabel: [],
  iconToUse: Icon.Sprites.CHEVRON_DOWN,
  getComponentClasses: (/* istanbul ignore next */
  function getComponentClasses() {})
});
var RawSingleSelect = SingleSelect;
var ValidatedSingleSelect = withValidation(selectWrapper(SingleSelect));
var SingleSelect$1 = selectWrapper(SingleSelect);
export { MultiSelect$1 as MultiSelect, RawNestedSelect as NestedSelect, RawMultiSelect, RawNestedSelect, RawSelectOptions, RawSingleSelect, SelectOptions$1 as SelectOptions, SingleSelect$1 as SingleSelect, ValidatedMultiSelect, ValidatedNestedSelect, ValidatedSingleSelect };
